varying vec2 vUv; 
uniform sampler2D logo;
uniform float u_zoom;
uniform vec3 colorOne;
uniform vec3 colorTwo;
uniform bool u_win;

vec2 rotateCW(vec2 p, float a)
{
	mat2 m = mat2(cos(a), -sin(a), sin(a), cos(a));
	return p * m;
}
void main()
{
    vec2 ndc = (((vUv-0.5)*2.)*u_zoom);
    ndc.x *=-1.;
    vec2 rotatedUv = rotateCW(ndc, 3.14159*0.);
    // 
    float logoMask = texture2D(logo, rotatedUv+0.5).x;
    logoMask = u_win ?  clamp(logoMask, 0., 1.): clamp(logoMask, 0., 0.);
    float rougphMask = clamp(logoMask, 0.3, 0.4);

    
csm_Roughness *= rougphMask;

csm_DiffuseColor.rgb = mix(colorOne, colorTwo, logoMask);




}